import Vue from 'vue';
import VueRouter from 'vue-router';
import {AUTH_TOKEN} from "../vue-apollo";


Vue.use(VueRouter);

const routes = [
    {
        path: '/:url',
        props: true,
        component: () => import('../views/Frame.vue'),
        children: [
            {
                path: '',
                component: () => import('../views/Event.vue'),
                props: true,
                children: [
                    {
                        path: '',
                        name: 'Foyer',
                        component: () => import('../views/Foyer.vue'),
                        props: true,
                    },
                    {
                        path: 'sponsors',
                        name: 'Sponsors',
                        component: () => import('../views/Sponsors.vue'),
                        props: true,
                    },
                    {
                        path: 'posters',
                        name: 'Poster',
                        component: () => import('../views/Posters.vue'),
                        props: true,
                    },
                ],
            },
            {
                path: 'room/:id',
                name: 'Room',
                component: () => import('../views/Room.vue'),
                props: true,
            },
            {
                path: 'login',
                name: 'Login',
                component: () => import('../views/Login.vue'),
                props: true,
            },
            {
                path: 'doc_check',
                name: 'DocCheck',
                props: true,
                component: () => import('../views/DocCheck.vue'),
            },
        ],
    },
    {
        path: '/:url/logout',
        name: 'Logout',
        component: () => import('../views/Logout.vue'),
        props: true,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    if(to.query.dc === "1") {
        localStorage.setItem(`${AUTH_TOKEN}_doc_check`, to.query.dc_timestamp)
    }
    next()
})

export default router;
